module.exports = __webpack_public_path__ + "fed61b501f6892ebfbd8229f8aec9b8a.png";